import {Theme} from "@mui/material";

import { palette } from '../../theme';
export const locationPaperStyle = (theme: Theme) => ({
    p: 3,
    mb: 3,
    width: 486,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 1,
    borderRadius: 2,
    border: "1px solid",
    borderColor: theme.palette.grey[300],
    backgroundColor: theme.palette.background.paper,
    position: "relative"
});

export const locationGroupBadgeStyle = {
    height: "32px",
    padding: "4px 6px",
    borderRadius: "8px",
    border: "1px solid rgba(72, 51, 89, 0.20)",
    backgroundColor: palette.surface.tint,
    color: palette.primary.main,
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    fontWeight: 400
}